<template>
    <v-container>
      <v-col >
        <v-img
          src="@/assets/madrid360.jpg"
          height="425"
        ></v-img>
      </v-col>
      <v-col>
        <h2 class="text-justify">{{ $t('servicioZbeMadrid') }}</h2>
        <br>
        <p class="text-justify">{{ $t('descripcionZBEMadrid1') }}</p>
        <p class="text-justify">{{ $t('descripcionZBEMadrid2') }}</p>
        <p class="text-justify">{{ $t('descripcionZBEMadrid3') }}<a href="https://madrid360.es/como-me-afecta/" target="_blank"> {{$t('accede')}}</a></p>
      </v-col>
    </v-container>
</template>

<script>
export default {
  name: "PaginaZBE",

  data: () => ({
  })
};
</script>
